"use client";

import CommonCreate from "@/components/common/Create";
import { expenseAndService } from "@/utils/objects";
import { useState } from "react";
import ExpenseForm from "../forms/ExpenseForm";
import { SelectedValue } from "@/interface/dataInterface";
import { mergeDateAndTime } from "@/utils/formChange";

const ExpenseCreate = () => {
  const [formProp, setFormProp] = useState(expenseAndService);
  const [otherData, setOtherData] = useState<SelectedValue[]>([]);

  return (
    <CommonCreate title="Create" resource="expenses" data={{...formProp, date: mergeDateAndTime(formProp.date, formProp.time), vehicle_id: +formProp.vehicle_id, expense_type_list: otherData}}>
      <ExpenseForm formProp={formProp} setFormProp={setFormProp} otherData={otherData} setOtherData={setOtherData} />
    </CommonCreate>
  );
};

export default ExpenseCreate;
